import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Injectable} from '@angular/core';
import {DipRegistrationContextService} from '../dip-registration-context.service';


@Injectable()
export class DipRegistrationRestartGuardService  {


  constructor(private router: Router,
              private dipRegistrationContextService: DipRegistrationContextService) {
  }

  canDeactivate(component: any, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): boolean {
    if (this.router.getCurrentNavigation().trigger === 'popstate') {
      this.router.navigate(['overview'], this.dipRegistrationContextService.buildParams());
    }
    return true;
  }

}
